import { render, staticRenderFns } from "./SupplierPage.vue?vue&type=template&id=37bd1769&scoped=true&"
import script from "./SupplierPage.vue?vue&type=script&lang=js&"
export * from "./SupplierPage.vue?vue&type=script&lang=js&"
import style0 from "./SupplierPage.vue?vue&type=style&index=0&id=37bd1769&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37bd1769",
  null
  
)

export default component.exports